import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_BASE_URL : 'http://localhost:3001';

export const updateFirstName = async (firstname) => {
    try {
        const response = await axios.put(`${baseURL}/api/update-first-name`, {
            firstname
        }, {
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const updateLastName = async (lastname) => {
    try {
        const response = await axios.put(`${baseURL}/api/update-last-name`, {
            lastname
        }, {
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const updateEmail = async (email) => {
    try {
        const response = await axios.put(`${baseURL}/api/update-email`, {
            email
        }, {
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};